export const CITINOMADI_GRAVE_ID_URL_PARAM = 'CITINOMADI_GRAVE_ID';
export const HAUTAKARTTA_GRAVE_ID_URL_PARAM = 'HAUTAKARTTA_GRAVE_ID';
